import { COMMAND_PALETTE_SHORTCUT } from "components/CommandPalette/constants";
import { useHotkeys } from "react-hotkeys-hook";

export const useCommandPaletteShortcut = (onOpen: () => void): void => {
  useHotkeys(COMMAND_PALETTE_SHORTCUT, onOpen, {
    preventDefault: true,
    enableOnFormTags: true,
  });
};
